import { computed } from 'vue'
import L from 'leaflet'
import type { BaseMapTileLayerType } from '@map-sdk/components'

// interface BaseMapTileLayerType {
//   iconUrl?: string // 显示图标
//   type: string // 类型
//   label: string // 名称
//   url: string // 瓦片地址
//   id?: string | undefined
//   minZoom?: number | undefined
//   maxZoom?: number | undefined
//   subdomains?: string | string[] | undefined
//   errorTileUrl?: string | undefined
//   checked?: boolean
// }

export function useUtilsHooks() {
  const isMobile = computed(() => {
    const userAgent =
      navigator.userAgent || navigator.vendor || (window as any).opera
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
      userAgent
    )
  })

  const getMapTitleLayer = (
    map: any,
    baseMapTitleLayers: BaseMapTileLayerType[]
  ) => {
    const mapTypes = map._options?.mapTypes
    return (
      (baseMapTitleLayers &&
        baseMapTitleLayers.filter((item: BaseMapTileLayerType) =>
          mapTypes?.includes(item.type)
        )) ||
      baseMapTitleLayers
    )
  }

  /**
   * 选择地图图层
   * @param map 地图实力
   * @param titleLayer 图层配置信息
   * @param errorTitleLayer 图层异常加载新的图层地址
   * @returns
   */
  const switchBaseMap = (
    map: any,
    titleLayer: BaseMapTileLayerType,
    errorTitleLayer?: string
  ) => {
    if (!map) return
    map.eachLayer((layer: any) => {
      if (layer instanceof L.TileLayer) {
        map.removeLayer(layer)
      }
    })
    const { type } = titleLayer
    const newBaseMap = L.tileLayer(titleLayer.url, {
      maxZoom: 19,
      ...titleLayer,
    })
    if (type === 'MT_SEA') {
      map.setMaxZoom(18)
    } else {
      map.setMaxZoom(13)
    }
    if (errorTitleLayer) {
      newBaseMap.on('tileerror', (e) => {
        const tile = e.tile
        const { x, y, z } = e.coords
        // 清除失败的图块，避免显示空白或错误图标
        tile.src = ''
        // 尝试使用新的地址加载图块
        tile.onload = L.Util.falseFn // 清除之前的onload监听器，避免重复触发
        tile.onerror = L.Util.falseFn // 清除之前的onerror监听器，避免重复触发
        tile.src = errorTitleLayer
          .replace('{z}', `${z}`)
          .replace('{x}', `${x}`)
          .replace('{y}', `${y}`)
      })
    }
    newBaseMap.addTo(map as any)
    map.mapType = titleLayer.type
    map.fire('baselayerchange', titleLayer)
  }

  return {
    isMobile,
    getMapTitleLayer,
    switchBaseMap,
  }
}
